import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "InfraPilot-community-server 软件包"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 获取 InfraPilot 一键安装离线包 ")
], -1 /* HOISTED */)
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: $data.modal.show,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (($data.modal.show) = $event)),
    footer: null,
    wrapClassName: "modal_downloadIFP",
    destroyOnClose: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, {
        type: "flex",
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, { flex: "100px" }, {
            default: _withCtx(() => [
              ($data.modal.href)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "button_n_3",
                    target: "_blank",
                    href: $data.modal.href
                  }, " 立即下载 ", 8 /* PROPS */, _hoisted_2))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible"]))
}